<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Конструктор сайта</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
            >Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте настроим ваш сайт.</p>

            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Сайт&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>На&nbsp;открывшейся странице выберите в&nbsp;меню слева нужный раздел для настройки.</p>

            <p>Справа можно увидеть статус сайта, ссылку на&nbsp;него и&nbsp;кнопки для управления публикацией.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="osnovnye-nastroiki"
            class="typography__headline2"
            >Основные настройки
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Основные&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Заголовок и&nbsp;описание&raquo; можно задать тексты, использующиеся при предпросмотре
              ссылки на&nbsp;сайт или в&nbsp;названии вкладки в&nbsp;браузере.
            </p>

            <p>После заполнения текста сообщения нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Бейджик и&nbsp;favicon&raquo; можно загрузить изображения, использующиеся при предпросмотре
              ссылки на&nbsp;сайт или в&nbsp;вкладке сайта в&nbsp;браузере.
            </p>

            <p>После загрузки изображений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Фирменный цвет&raquo; можно задать акцентный цвет, использующийся в&nbsp;разных элементах
              на&nbsp;сайте.
            </p>

            <p>Справа можно посмотреть как он&nbsp;будет выглядеть на&nbsp;примере разных видов кнопок.</p>

            <p>После выбора цвета нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>В&nbsp;SEO пока нет настроек&nbsp;&mdash; раздел находится в&nbsp;разработке.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;&laquo;Другое&raquo; можно управлять оставшимися настройками.</p>

            <p>Фамилии сотрудников по-умолчанию скрыты для клиентов на&nbsp;сайте. Их&nbsp;можно включить.</p>

            <p>
              Лейбл Powered by&nbsp;MyDonut внизу сайта на&nbsp;всех страницах можно отключить только
              на&nbsp;определенных тарифах.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="glavnyaya-stranitsa"
            class="typography__headline2"
            >Главная страница
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Главная страница&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Баннеры&raquo; можно включить отображение баннеров на&nbsp;главной странице сайта
              и&nbsp;добавить&nbsp;их.
            </p>

            <p>
              Если хотите их&nbsp;использовать, для начала включите их&nbsp;отображение. После нажмите &laquo;Добавить
              баннер&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>Выберите куда он будет вести и загрузите изображение самого баннера.</p>

            <p>
              После добавления баннера и&nbsp;завершения всех настроек, нажмите &laquo;Сохранить&raquo; внизу блока.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-12.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Тексты&raquo; можно отредактировать тексты, использующиеся на&nbsp;главной странице
              на&nbsp;кнопках перехода в&nbsp;разделы.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-13.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;&laquo;Другое&raquo; можно управлять оставшимися настройками.</p>

            <p>
              На&nbsp;главной странице внизу есть блок с&nbsp;контактами проекта. По-умолчанию оно отображаются,
              но&nbsp;если необходимо их&nbsp;можно скрыть.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-14.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="razdel-o-kompanii"
            class="typography__headline2"
            >Раздел &laquo;О&nbsp;компании&raquo;
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;О&nbsp;компании&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-15.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;&laquo;Общее&raquo; можно изменить название раздела.</p>

            <p>
              Под разделом &laquo;Общее&raquo; можно добавить новую информационную страницу по&nbsp;кнопке
              &laquo;Добавить страницу&raquo;.
            </p>

            <p>
              На&nbsp;этих страницах можно расположить любую информацию&nbsp;&mdash; историю компании,
              <BaseLink
                target="_blank"
                to="/faq/articles/politiki-konfidencialnosti"
                >политики конфиденциальности или cookies</BaseLink
              >, условия акций и&nbsp;другое.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-16.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>После добавления новой страницы можно будет перейти к&nbsp;её&nbsp;настройке и&nbsp;редактированию.</p>

            <p>
              По-умолчанию она скрыта с&nbsp;сайта, чтобы можно было сначала её&nbsp;настроить и&nbsp;показать когда
              будет готова.
            </p>

            <p>Ниже нужно ввести название страницы и можно задать ей конечную ссылку для открытия.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-17.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Теперь можно перейти к&nbsp;редактированию содержания страницы по&nbsp;кнопке &laquo;Редактировать
            страницу&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-18.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Справа откроется редактор, в&nbsp;котором можно ввести текст, добавить изображения и&nbsp;другие нужные
              элементы.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; над редактором.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-19.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После сохранения, справа можно посмотреть превью получившейся страницы.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-20.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="razdel-tovary"
            class="typography__headline2"
            >Раздел &laquo;Товары&raquo;
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Товары&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-21.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>В&nbsp;&laquo;Категории&raquo; можно выбрать вид отображаемых категорий.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-22.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После выбора нажмите &laquo;Сохранить&raquo; внизу блока.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-23.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>В&nbsp;&laquo;Карточки товаров&raquo; можно выбрать вид отображаемых карточек и&nbsp;настроить значки.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-24.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-25.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Страница успеха&raquo; можно отредактировать дополнительный текст, отображаемый
              на&nbsp;странице успешного оформления заказа.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-26.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="razdel-uslugi"
            class="typography__headline2"
            >Раздел &laquo;Услуги&raquo;
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Услуги&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-27.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>В&nbsp;&laquo;Категории&raquo; можно выбрать вид отображаемых категорий.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-28.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После выбора нажмите &laquo;Сохранить&raquo; внизу блока.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-29.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>В&nbsp;&laquo;Карточки услуг&raquo; можно выбрать вид отображаемых карточек.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-30.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-31.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Страница успеха индивидуальных записей&raquo; можно отредактировать дополнительный текст,
              отображаемый на&nbsp;странице успешного оформления индивидуальной записи.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-32.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Страница успеха групповых записей&raquo; можно отредактировать дополнительный текст,
              отображаемый на&nbsp;странице успешного оформления групповой записи.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-33.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Страница успеха заявки&raquo; можно отредактировать дополнительный текст, отображаемый
              на&nbsp;странице успешного оформления заявки.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-34.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="politiki-i-cookie"
            class="typography__headline2"
            >Политики и cookie
          </FaqArticlesBlockHeading>

          <p>В&nbsp;меню слева выберите раздел &laquo;Политики и&nbsp;cookie&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-35.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;&laquo;Cookie&raquo; можно настроить сообщение о&nbsp;использовании cookie.</p>

            <p>
              Помимо самого текста сообщения, в&nbsp;него нужно вставить ссылку на&nbsp;страницу с&nbsp;описанием
              собираемых данных. Эту страницу необходимо самостоятельно добавить и&nbsp;заполнить в&nbsp;настройках
              сайта в&nbsp;<BaseLink to="/faq/articles/konstruktor-sayta#razdel-o-kompanii"
                >разделе &laquo;О&nbsp;компании&raquo;</BaseLink
              >, описанном выше. Также перейти в&nbsp;раздел можно нажав здесь &laquo;Редактировать страницы&raquo;.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-36.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Заказы&raquo; можно настроить текст о&nbsp;принятии политик на&nbsp;странице оформления
              заказа.
            </p>

            <p>
              Помимо самого текста сообщения, в&nbsp;него нужно вставить ссылку на&nbsp;страницу с&nbsp;описанием. Эту
              страницу необходимо самостоятельно добавить и&nbsp;заполнить в&nbsp;настройках сайта в&nbsp;<BaseLink
                to="/faq/articles/konstruktor-sayta#razdel-o-kompanii"
                >разделе &laquo;О&nbsp;компании&raquo;</BaseLink
              >, описанном выше. Также перейти в&nbsp;раздел можно нажав здесь &laquo;Редактировать страницы&raquo;.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-37.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Записи&raquo; можно настроить текст о&nbsp;принятии политик на&nbsp;странице оформления
              записи.
            </p>

            <p>
              Помимо самого текста сообщения, в&nbsp;него нужно вставить ссылку на&nbsp;страницу с&nbsp;описанием. Эту
              страницу необходимо самостоятельно добавить и&nbsp;заполнить в&nbsp;настройках сайта в&nbsp;<BaseLink
                to="/faq/articles/konstruktor-sayta#razdel-o-kompanii"
                >разделе &laquo;О&nbsp;компании&raquo;</BaseLink
              >, описанном выше. Также перейти в&nbsp;раздел можно нажав здесь &laquo;Редактировать страницы&raquo;.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-38.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;&laquo;Заявки&raquo; можно настроить текст о&nbsp;принятии политик на&nbsp;странице оформления
              заявки.
            </p>

            <p>
              Помимо самого текста сообщения, в&nbsp;него нужно вставить ссылку на&nbsp;страницу с&nbsp;описанием. Эту
              страницу необходимо самостоятельно добавить и&nbsp;заполнить в&nbsp;настройках сайта в&nbsp;разделе
              &laquo;О&nbsp;компании&raquo;, описанном выше. Также перейти в&nbsp;раздел можно нажав здесь
              &laquo;Редактировать страницы&raquo;.
            </p>

            <p>После внесения изменений нажмите &laquo;Сохранить&raquo; внизу блока.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-39.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="predprosmotr-i-publikatsiya-sayta"
            class="typography__headline2"
            >Предпросмотр и публикация сайта
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>После настройки сайта, его нужно опубликовать.</p>

            <p>Сделать это можно на&nbsp;главной странице раздела по&nbsp;кнопке &laquo;Опубликовать&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-40.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После внесения любых изменений, чтобы они применились на&nbsp;сайте, нужно также их&nbsp;публиковать.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-41.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>Также опубликовать изменения можно на&nbsp;любой из&nbsp;страниц с&nbsp;редактированием.</p>

            <p>По&nbsp;кнопке &laquo;Предпросмотр&raquo; можно перед публикацией посмотреть внесенные изменения.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-42.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>На&nbsp;предпросмотре, когда убедились что все верно, также можно опубликовать новую версию сайта.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/konstruktor-sayta-43.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как настроить сайт разобрались. Самое время перейти к&nbsp;<BaseLink
              class="ui-link-secondary"
              to="/faq/articles/sayt-dlya-klientov"
            >
              изучению сайта для клиентов </BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Сайт",
    url: "/faq/categories/sayt",
  },
  {
    name: "Конструктор сайта",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Основные&nbsp;настройки",
    url: "osnovnye-nastroiki",
  },
  {
    name: "Главная&nbsp;страница",
    url: "glavnyaya-stranitsa",
  },
  {
    name: "Раздел&nbsp;&laquo;О&nbsp;компании&raquo;",
    url: "razdel-o-kompanii",
  },
  {
    name: "Раздел&nbsp;&laquo;Товары&raquo;",
    url: "razdel-tovary",
  },
  {
    name: "Раздел&nbsp;&laquo;Услуги&raquo;",
    url: "razdel-uslugi",
  },
  {
    name: "Политики&nbsp;и&nbsp;cookie",
    url: "politiki-i-cookie",
  },
  {
    name: "Предпросмотр&nbsp;и&nbsp;публикация сайта",
    url: "predprosmotr-i-publikatsiya-sayta",
  },
];

const relatedArticles = [
  {
    name: "Сайт для клиентов",
    slug: "sayt-dlya-klientov",
  },
  {
    name: "Информационные страницы",
    slug: "informatsionnyye-stranitsy",
  },
  {
    name: "Политики конфиденциальности",
    slug: "politiki-konfidencialnosti",
  },
];

useSeoMeta({
  title: "Конструктор сайта",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
